import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {isMobile} from '@aoflmkt/is-mobile';
import {layoutSdo} from '../sdo-layout';
import {accessibilityMixin} from '../accessibility-mixin';

/**
 * @summary DdMenuButton
 * @extends {AoflElement}
 */
@customElement('dd-menu-button')
class DdMenuButton extends accessibilityMixin(AoflElement) {
  /**
   * Creates an instance of DdMenuButton.
   */
  constructor() {
    super();
    this.clickOrTouchEvent = (isMobile.any) ? 'touchstart' : 'click';
  }

  /**
   * @readonly
   */
  static is = 'dd-menu-button';

  /**
   * @return {Object}
   */
  @property({type: Object, attribute: false, store: layoutSdo, mapState: 'ddMenu'})
  ddActive = false;

  @property({type: String, attribute: 'menu-color'})
  color = '';

  /**
   *
   * @param {Event} e
   */
  clickHandler(e) {
    if (e.cancelable) e.preventDefault();
    e.stopPropagation();

    // Handles IOS behavior where input fields don't lose focus when tapping outside of them
    this.shadowRoot.querySelector('#menu-button').focus();
    layoutSdo.ddMenu = !layoutSdo.ddMenu;
    layoutSdo.contentOverlay = !layoutSdo.contentOverlay;
    layoutSdo.footerOverlay = !layoutSdo.footerOverlay;
  }

  /**
   *
   */
  closeMenu() {
    layoutSdo.ddMenu = false;
    layoutSdo.contentOverlay = false;
    layoutSdo.footerOverlay = false;
  }

  /**
   *
   */
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener(this.clickOrTouchEvent, this.closeMenu);
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeMenu();
      }
    });
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }

  /**
   *
   */
  disconnectedCallback() {
    window.removeEventListener(this.clickOrTouchEvent, this.closeMenu);
    window.removeEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeMenu();
      }
    });
    super.disconnectedCallback();
  }
}

export default DdMenuButton;
